import { put, takeEvery } from "redux-saga/effects";
import { actions } from "redux-store/index";

export function* postNotificationSaga() {
  yield takeEvery(actions.postNotifications.success.type, function* () {
    yield put(actions.setIsNotificationDialogOpen(false));
  });
}
